<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">ผู้ดูแลระบบ</span>
      <v-scroll-x-transition>
        <div style="display: flex" v-show="!adminFormShow">
          <v-text-field
            v-model="search"
            label="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-text-field>
          <v-autocomplete
            v-model="filterAdminRole"
            :items="adminRoles"
            item-text="title_th"
            item-value="title_th"
            label="สิทธิ์ใช้งานระบบ"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          ></v-autocomplete>
          <v-select
            v-model="filterActive"
            :items="actives"
            item-text="itemText"
            item-value="itemValue"
            label="เลือกตามสถานะ"
            clearable
            flat
            solo
            dense
            hide-details
            style="width: 200px; padding: 0 5px"
          >
            <template v-slot:item="{ item }">
              <span v-if="item.itemValue === true">
                <v-icon small color="success">mdi-check-circle</v-icon>
                {{ item.itemText }}
              </span>
              <span v-else>
                <v-icon small color="error">mdi-close-circle</v-icon>
                {{ item.itemText }}
              </span>
            </template>
          </v-select>
          <v-btn
            :disabled="
              loading ||
              (uiCtrl && !uiCtrl.isEnable('btn:::admin:company_admin:create'))
            "
            style="margin-top: 1px"
            color="primary"
            @click="handleAddAdminForm"
          >
            <v-icon small left>mdi-plus</v-icon>เพิ่มผู้ดูแลระบบ
          </v-btn>
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      loading-text="Loading... Please wait"
      :search="search"
      :headers="headers"
      :items="admins"
      :custom-filter="filterValue"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.is_active="{ item }">
        <v-switch
          v-model="item.is_active"
          hide-details
          class="mt-0 pt-0"
          disabled
        ></v-switch>
      </template>
      <template v-slot:item.start_time="{ item }">
        <span v-if="item.start_time">
          {{ item.start_time | dateTimeAdminFormat }}
        </span>
        <span v-else>-</span>
      </template>
      <template v-slot:item.expire_time="{ item }">
        <span v-if="item.expire_time">
          {{ item.expire_time | dateTimeAdminFormat }}
        </span>
        <span v-else>-</span>
      </template>
    </v-data-table>
    <AdminForm
      :formShow="adminFormShow"
      :formAction="adminFormAction"
      :admin="admin"
      :adminInit="adminInit"
      @isAdminDataChange="handleAdminFormDataChange"
      @formActionCompleted="handleAdminFormActionCompleted"
      @onReset="handleAdminFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="adminFormShow && adminFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import AdminForm from '@/views/admin/AdminForm.vue'

export default {
  components: {
    AdminForm,
    ConfirmDialog,
  },
  data() {
    return {
      dialogForbidden: false,
      sortBy: ['email'],
      sortDesc: [false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      loading: true,
      search: '',
      filterAdminRole: '',
      filterActive: '',
      actives: [
        { itemText: 'เปิดการใช้งาน', itemValue: true },
        { itemText: 'ปิดการใช้งาน', itemValue: false },
      ],
      adminFormShow: false,
      adminFormAction: '',
      admin: {},
      adminInit: {},
      isAdminDataChange: false,
      timeout: null,
    }
  },
  filters: {
    dateTimeAdminFormat: function (value) {
      return moment.utc(value).format('DD/MM/YYYY, HH:mm')
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    headers() {
      return [
        {
          text: 'สิทธิ์ใช้งานระบบ',
          align: 'start',
          value: 'role.title_th',
          filter: (value) => {
            if (!this.filterAdminRole) {
              return true
            }
            return value === this.filterAdminRole
          },
        },
        { text: 'อีเมล', value: 'email' },
        {
          text: 'เปิด/ปิด การใช้งาน',
          value: 'is_active',
          filter: (value) => {
            if (!this.filterActive && this.filterActive !== false) {
              return true
            }
            return value === this.filterActive
          },
        },
        { text: 'เริ่มใช้งาน', value: 'start_time' },
        { text: 'หมดอายุ', value: 'expire_time' },
      ]
    },
    admins() {
      return this.$store.state.admin.admins
    },
    adminRoles() {
      return this.$store.state.role.roles
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'ผู้ดูแลระบบ',
        disabled: true,
      },
    ])

    this.loadData()
  },
  methods: {
    ...mapActions({
      fetchAdmins: 'admin/fetchAdmins',
      fetchAdminRoles: 'role/fetchRoles',
      editAdminActive: 'admin/editAdminActive',
    }),
    filterValue(value, search, item) {
      return (
        item.role.title_th.toLowerCase().includes(search.toLowerCase()) ||
        item.email.toLowerCase().includes(search.toLowerCase()) ||
        moment
          .utc(item.start_time)
          .format('DD/MM/YYYY, HH:mm')
          .toLowerCase()
          .includes(this.search.toLowerCase()) ||
        moment
          .utc(item.expire_time)
          .format('DD/MM/YYYY, HH:mm')
          .toLowerCase()
          .includes(this.search.toLowerCase())
      )
    },
    editActiveItem(item) {
      this.loading = true

      const adminActiveUpdate = {
        company_admin_id: item.company_admin_id,
        is_active: item.is_active,
      }

      this.editAdminActive(adminActiveUpdate)
        .then(() => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'แก้ไขข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)
        })
        .catch((error) => {
          this.loading = false
          this.loadData()

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    classRowSelected(row) {
      if (this.admin.company_admin_uuid === row.company_admin_uuid)
        return 'row-selected'
    },
    setDataRowSelected(row) {
      if (
        this.uiCtrl &&
        !this.uiCtrl.isEnable('row:::admin:company_admin:get')
      ) {
        this.dialogForbidden = true
        return
      }

      row.role_uuid = row.role.role_uuid
      row.date_start = row.start_time
        ? moment.utc(row.start_time).format('YYYY-MM-DD')
        : ''
      row.time_start = row.start_time
        ? moment.utc(row.start_time).format('HH:mm')
        : ''
      row.date_expire = row.expire_time
        ? moment.utc(row.expire_time).format('YYYY-MM-DD')
        : ''
      row.time_expire = row.expire_time
        ? moment.utc(row.expire_time).format('HH:mm')
        : ''

      if (this.admin.company_admin_uuid === row.company_admin_uuid) {
        this.adminFormShow = false
        this.adminFormAction = ''
        this.admin = {}
        this.adminInit = {}
      } else {
        this.adminFormShow = true
        this.adminFormAction = 'edit'
        this.admin = { ...row }
        this.adminInit = { ...row }
      }
    },
    handleRowSelected(row) {
      if (this.isAdminDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddAdminForm() {
      this.adminFormShow = true
      this.adminFormAction = 'add'
      // const initData = {
      //   date_start: moment().format('YYYY-MM-DD'),
      //   time_start: moment().format('HH:mm'),
      //   date_expire: moment()
      //     .add(1, 'year')
      //     .format('YYYY-MM-DD'),
      //   time_expire: moment().format('HH:mm')
      // }
      // this.admin = { ...initData }
      this.admin = {}
      this.adminInit = {}
    },
    handleAdminFormDataChange(value) {
      this.isAdminDataChange = value
    },
    handleAdminFormReset(formAction) {
      if (formAction === 'edit') this.admin = { ...this.adminInit }
    },
    handleAdminFormActionCompleted(formAction) {
      this.admin = {}
      this.adminInit = {}
      this.adminFormShow = false
      this.adminFormAction = ''
    },
    loadData() {
      const { company_uuid } = this.$store.state.authentication.company

      const admins = this.fetchAdmins(company_uuid)
      const adminRoles = this.fetchAdminRoles({
        companyUuid: company_uuid,
        roleType: 'company_admin',
      })

      Promise.all([admins, adminRoles])
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.adminFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isAdminDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
